export interface PlayerLabel {
    _id: string;
    code: string;
    hr: string;
    en: string;
}

export const DEFAULT_PLAYER_LABELS: Omit<PlayerLabel, '_id'>[] = [
    {code: 'elements-yesnoquestion-yes', hr: 'Da', en: 'Yes'},
    {code: 'elements-yesnoquestion-no', hr: 'Ne', en: 'No'},
    {code: 'elements-question-try', hr: 'Potvrdi', en: 'Confirm'},
    {code: 'elements-question-done', hr: 'Gotovo', en: 'Done'},
    {code: 'elements-multiselect-select', hr: 'Odaberi...', en: 'Select...'},
    {code: 'elements-multiselect-start-typing', hr: 'Počnite tipkati...', en: 'Start typing...'},
];

export const LOCALE_LABEL_ITEMS: {code: string; nameKey: string}[] = [
    {code: 'elements-yesnoquestion-yes', nameKey: 'presEditPage.settings.locale.labels.yesAnswer'},
    {code: 'elements-yesnoquestion-no', nameKey: 'presEditPage.settings.locale.labels.noAnswer'},
    {code: 'elements-question-try', nameKey: 'presEditPage.settings.locale.labels.tryButton'},
    {code: 'elements-question-done', nameKey: 'presEditPage.settings.locale.labels.doneButton'},
    {code: 'elements-multiselect-select', nameKey: 'presEditPage.settings.locale.labels.selectPlaceholder'},
    {code: 'elements-multiselect-start-typing', nameKey: 'presEditPage.settings.locale.labels.startTypingPlaceholder'},
];
